import { Container, Heading } from '@boltenergy-be/design-system'
import ReviewRatings from 'components/review-ratings/ReviewRatings'
import styles from './ReviewSection.module.scss'
import { ReviewSectionProps } from './types'

const ReviewSection = ({ title, description }: ReviewSectionProps) => {
  return (
    <Container as="section" classnames={{ content: styles['reviews-content'] }}>
      <Heading as="h2" variant="d3" className={styles.heading}>
        {title}
      </Heading>
      <p className={styles.desc}>{description}</p>

      <ReviewRatings className={styles.ratings} />
    </Container>
  )
}

export default ReviewSection
